import React, { FC, useEffect } from 'react';

import { shouldShowServicePlanDetails, Styled } from './';
import { ITeroProposalProps } from './ITeroProposal.types';
import { ServicePlanTerm } from 'components/ITeroTermsConditionsModal';
import handleITeroCustomerNeeds from 'utils/handleITeroCustomerNeeds';
import { getServicePlanFee } from './ITeroProposal.helper';
import {
  RentalOrderDetails,
  ServicePlanDetails,
  StandardOrderDetails,
  ServicePlanDetailsProposalEMEA,
} from 'components/ITeroProposal';
import { useSendProposalViewedNotification } from 'reactQuery/mutations';
import { useI18n } from 'contexts/i18n';
import { isEMEAStore } from 'utils';
import ServicePlanTermEMEA from 'components/ITeroTermsConditionsModalEMEA/ServicePlanTermEMEA';

const ITeroProposal: FC<ITeroProposalProps> = ({ currentProposal }) => {
  const isMultipleScannerSubscriptions =
    currentProposal.lineitems.filter(item => item.subscriptions?.length > 0)
      .length > 1;
  const i18n = useI18n();
  const sendproposalViewedNotificationMutation =
    useSendProposalViewedNotification(currentProposal.proposalId);

  const { isServiceTermHideRequired, isRental } =
    handleITeroCustomerNeeds(currentProposal);

  useEffect(() => {
    sendproposalViewedNotificationMutation.mutate();
  }, []);

  const servicePlanFee = getServicePlanFee(currentProposal);

  return (
    <>
      <Styled.SummaryTitle>{i18n['Order Details']}</Styled.SummaryTitle>
      {isRental ? (
        <RentalOrderDetails currentProposal={currentProposal} />
      ) : (
        <StandardOrderDetails
          currentProposal={currentProposal}
          isServiceTermHideRequired={isServiceTermHideRequired}
        />
      )}

      {shouldShowServicePlanDetails(currentProposal) && (
        <>
          {isEMEAStore() ? (
            <>
              <ServicePlanDetailsProposalEMEA
                currentProposal={currentProposal}
                isMultipleScannerSubscriptions={isMultipleScannerSubscriptions}
              />
              <ServicePlanTermEMEA servicePlanFee={servicePlanFee} />
            </>
          ) : (
            <>
              <ServicePlanDetails
                currentProposal={currentProposal}
                isMultipleScannerSubscriptions={isMultipleScannerSubscriptions}
                servicePlanFee={servicePlanFee}
              />
              <ServicePlanTerm servicePlanFee={servicePlanFee} />
            </>
          )}
        </>
      )}
    </>
  );
};

export default ITeroProposal;
